import React, {useState} from 'react';
import UploadFilesForm from "../../../../form/UploadFilesForm";
import ModelFileService from "../../../../../API/model-estimate/file/ModelFileService";

const UploadModelDetailFileForm = ({
                                       labelForm,
                                       change,
                                       setChange,
                                       estimateId,
                                       handleModalAlert
                                   }) => {

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleUpload = async (event) => {

        event.preventDefault();

        ModelFileService.uploadModelDetailsFile(selectedFiles, estimateId)
            .then(function () {
                setChange(!change)
                handleModalAlert("Фйлы загружены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(function () {
                event.target.reset();
                setSelectedFiles([])
            })

    }

    return (
        <div>
            <UploadFilesForm
                handleUpload={handleUpload}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                label={labelForm}
            />
        </div>
    );
};

export default UploadModelDetailFileForm;